
export const buildParameter = {
         SaveDetail: (id, formdata) => {
           let param = {
             ENCRYPT_ID: id,
             ENCRYPT_NAME: formdata.ENCRYPT_NAME,
             ENCRYPT_TYPE_ID: formdata.ENCRYPT_TYPE_ID,
             ACTIVE: formdata.ACTIVE,
           };
           return param;
         },
       };
